import * as api from '@gitbook/api-client';
import { METER_PRICES } from '@gitbook/app-pricing';
import { Description, Heading, Panel, PanelBody, PanelHeader } from '@gitbook/spine-react';

import { BillingMeterUsageChart, PrettyDollarNumber } from '../../../Components';

export function TranslationsUsageOverview(props: { organizationId: string }) {
    const { organizationId } = props;
    const meter = METER_PRICES[api.BillingMeter.TranslationWords];

    return (
        <Panel>
            <PanelHeader>
                <Heading>Translation usage</Heading>
                <Description>
                    Translations are priced at <PrettyDollarNumber value={meter.flatInitialPrice} />{' '}
                    for up to {meter.startingAt.toLocaleString()} words per month; after that{' '}
                    <PrettyDollarNumber value={meter.pricePerBatch} /> per{' '}
                    {meter.unitsPerBatch.toLocaleString()} words.
                </Description>
            </PanelHeader>
            <PanelBody>
                <BillingMeterUsageChart
                    organizationId={organizationId}
                    meterName={api.BillingMeter.TranslationWords}
                />
            </PanelBody>
        </Panel>
    );
}
